<template>
        <div class="container">
            <!-- desktop version -->
            <div class="d-none d-md-flex flex-column">
                <o-bread-crumb-mobile>
                        <template v-slot:pageDetail>
                            Voucher Redeem
                        </template>
                        <template v-slot:pageDescription>
                            Set the quantity to exchange your point with the voucher
                        </template>
                </o-bread-crumb-mobile>
                <ul class="nav nav-pills justify-content-between ms-2 me-4 mt-2 mb-2">
                    <li class="nav-item points-nav-item">
                      <div class="points-display">
                        <o-badge :variant="'primary'" :pill="true">
                          My Points: {{ voucherRedeem.memberPoint }}
                        </o-badge>
                      </div>
                    </li>
                  </ul>
                <div v-if="error" class="alert alert-danger" role="alert">
                    {{ error }}
                </div>
                <div class="d-flex flex-column width-custom">
                    <o-widget-image @callback="handleWidgetClick" :voucher="vouchers"></o-widget-image>
                </div>
            </div>
            <!-- end desktop version -->
            <!-- mobile version -->
            <div class="d-flex d-md-none flex-column">
                <o-bread-crumb-mobile class="ms-5 mt-3">
                        <template v-slot:pageDetail>
                            Voucher Redeem
                        </template>
                        <template v-slot:pageDescription>
                            <div class="me-5">
                                Set the quantity to exchange your point with the voucher
                            </div>
                            <li class="nav-item points-nav-item-mobile">
                                <div class="points-display-mobile">
                                  <o-badge :variant="'primary'" :pill="true">
                                    My Points: {{ voucherRedeem.memberPoint }}
                                  </o-badge>
                                </div>
                              </li>
                        </template>
                </o-bread-crumb-mobile>
                <div class="d-flex flex-column align-items-center width-custom-mobile">
                    <o-widget-image @callback="handleWidgetClick" :voucher="vouchers" class="custom-height-image"></o-widget-image>
                </div>
            </div>
            <!-- end mobile version -->
        </div>
    
</template>

<script>
import { OBreadCrumbMobile, OWidgetImage} from '@/components/OmnihControl';
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { reactive, ref, onMounted, watch, computed} from 'vue'
// import dayjs from 'dayjs';

export default {
    name: 'MemberDealsRedeem',
    components: {
        OBreadCrumbMobile,
        OWidgetImage,
    },
    setup() {
        const store = useStore();

        const route = useRoute();

        const router = useRouter();

        const deducted = ref();
        
        const error = ref('');
        
        const state = reactive({
            qty : 1
        })

        const expiration = reactive({
            month: 0,
            day: 0,
            hour: 0
        });
        
        const vouchers = reactive({
            id: '',
            name: '',
            image_url: '',
            point: '',
            expiration: '',
            merchant_id: '',
            merchant: {},
            branch: {},
            avatar: {
                image_url: ''
            },
            desc:''
        })

        const voucherRedeem = reactive({
            voucher_id: '',
            quantity: '',
            expiration: ''
        })

        onMounted(() => {
            if (route.params.id_voucher) {
                loadState(route.params.id_voucher);
            }
        });

        const loadState = (id) => {
            store.dispatch('ClientVoucher/read_single',id).then((data)=>{
                console.log(data.memberPoint);
                
                vouchers.id = data.id
                vouchers.merchant_id = data.merchant_id
                vouchers.name = data.name
                vouchers.merchant_name = data.merchant.name
                vouchers.branch_name = data.merchant.branch.name
                vouchers.avatar.image_url = data.avatar.image_url
                vouchers.point = data.point
                vouchers.expiration = data.expiration
                vouchers.desc = data.desc
                
                deducted.value = vouchers.point;

                voucherRedeem.voucher_id = data.id
                voucherRedeem.quantity = state.qty
                voucherRedeem.expiration = data.expiration
                voucherRedeem.memberPoint = data.memberPoint
            })
        }

        const formattedExpiration = computed(() => {
            const expirationTimeInSeconds = vouchers.expiration;
            const currentDate = new Date();
            currentDate.setSeconds(currentDate.getSeconds() + expirationTimeInSeconds);

            const day = String(currentDate.getDate()).padStart(2, '0');
            const monthNames = [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ];
            const month = monthNames[currentDate.getMonth()];
            const year = currentDate.getFullYear();

            return `${day} ${month} ${year}`;
        });

        const redeem = () => {
            const isOnline = store.state.network?.isOnline ?? true;
            if (!isOnline) {
                error.value = 'You are currently offline. Please check your internet connection to redeem this voucher.';
                return;
            }

            // Check for negative points before proceeding
            if (voucherRedeem.memberPoint < 0) {
                error.value = 'Your points are negative. Please complete transactions to make your points positive before accessing vouchers.';
                return;
            }

            const data = {...voucherRedeem};
            data.merchant_id = vouchers.merchant_id;
            data.memberDeal = true;
            if (data.quantity > 0 && data.quantity <= 10) {                                
                store.dispatch('ClientVoucher/redeem', {data}).then(() => {
                    router.push({
                        name: 'client_voucher',
                    })
                }).catch((err) => {
                    if (err.response && err.response.status === 400) {
                        error.value = err.response.data.error;
                    } else if (!err.response) {
                        store.dispatch('network/probe');
                        error.value = 'Failed to redeem voucher due to connection issue. Please check your internet connection.';
                    } else {
                        error.value = "An error occurred. Please try again.";
                    }
                });
            }
        }

        watch(
            () => state.qty,
            (newVal) => {
                deducted.value = newVal * vouchers.point;
                voucherRedeem.quantity = newVal
            }
        )

        return {
            loadState,
            vouchers,
            deducted,
            formattedExpiration,
            state,
            redeem,
            voucherRedeem,
            expiration,
            error
        }
    }
}
</script>

<style scoped>
    .width-custom {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: fit-content;
    }

    .width-custom-mobile{
        min-width: 400px;
    }

    .custom-select .form-select{
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
        background-color: rgba(0, 0, 0, 0);
        border: 1px solid rgba(0, 0, 0, 0.25);
        border-radius: 4px;
    }

    .btn.btn-primary.btn-sm.btn-.text-white.btn-undefined.button-redeem {
        padding: 0.75rem;
    }

    .custom-points{
        font-size: 40px;
        font-weight: 700;
        color: rgba(74, 74, 74, 0.7);;
    }

    .number-deducted{
        font-size: 15px;
        color: rgba(0, 0, 0, 0.6);
    }

    .spinner{
        position: fixed;
        z-index: 3;
        top: 0;
        left: 0;
        background-color: rgba(255, 255, 255, 0.5);
        height: 100%;
        width: 100%;
    }
    .spinner-position{
        display: block;
        position: fixed;
        z-index: 1031;
        top: 50%;
        right: 50%;
        margin-top: 5px; 
        margin-left: 80px; 
    }

    .custom-height-image{
        width: 350px;
        height: 400px;
        margin-bottom: 16px; 
    }

    .points-nav-item {
        width: auto; /* Adjust the width as needed */
        position: absolute;
        right: 0;
        top: 0;
        margin: 1rem;
      }
      
      .points-display {
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #cb5b5b 0%, #fc6666 100%);
        border-radius: 50px;
        padding: 0.5rem 1rem;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        color: white;
        font-weight: bold;
        transition: transform 0.3s ease;
      }
      
      .points-display:hover {
        transform: scale(1.05);
      }
      
      .points-display o-badge {
        font-size: 1rem;
        font-weight: bold;
      }

      .points-nav-item-mobile {
        width: 35%; /* Adjust the width as needed */
        position: absolute;
        right: 8px;
        top: 14px;
        margin: 1rem;
        z-index: -1;
      }
      
      .points-display-mobile {
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #cb5b5b 0%, #fc6666 100%);
        border-radius: 50px;
        padding: 0.5rem 1rem;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        color: white;
        font-weight: bold;
        transition: transform 0.3s ease;
      }
      
      .points-display-mobile o-badge {
        font-size: 10px;
        font-weight: bold;
        left: 7px;
        position: absolute;
      }

</style>